import { createStore } from 'vuex'
import { display } from './display.module';
import { auth } from './auth.module';
export default createStore({
  modules: {
    auth:auth,
    display:display,
  }
})
